import type {FetchFn} from 'src/internal/transport/types';

export default function createBrowserFetch(): FetchFn {
  return (url, options) => {
    if (
      options.keepalive &&
      typeof navigator !== 'undefined' &&
      typeof navigator.sendBeacon === 'function'
    ) {
      navigator.sendBeacon(url, options.body);

      return Promise.resolve();
    }

    return fetch(url, options);
  };
}
